import { MyContext, ThemeType } from "../context/MyContext";
import { useContext, useEffect, useState } from "react";

export const useContextData = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error("MyContext must be used within a MyProvider");
  }
  const {
    userInfo,
    setUserInfo,
    setTheme,
    theme,
    setThemeMatchBattery,
    themeMatchBattery,
    setSelectedResult,
    selectedResult,
    photoUri,
    setPhotoUri,
    loading,
    setLoading,
    selectedFaceCard,
    setSelectedFaceCard,
    triggerRefetch,
    setTriggerRefetch,
  } = context;

  useEffect(() => {
    setTheme(context.theme);
    setUserInfo(context.userInfo);
  }, [context]);

  return {
    theme,
    setTheme,
    userInfo,
    themeMatchBattery,
    setThemeMatchBattery,
    setUserInfo,
    setSelectedResult,
    selectedResult,
    photoUri,
    setPhotoUri,
    loading,
    setLoading,
    selectedFaceCard,
    setSelectedFaceCard,
    triggerRefetch,
    setTriggerRefetch,
  };
};
